<template>
  <b-card
    no-body
    :img-src="toy.image"
    :img-alt="toy.name"
    img-top
    @click="handleCardClick"
  >
    <b-card-title
      class="flex-1 px-2 py-2 m-0 d-flex justify-content-between border-top"
      :class="statusClass"
    >
      <b-dropdown v-if="isActive || isPaused" no-caret class="btn-cancel">
        <template #button-content>
          <span class="fas fa-ellipsis-v" />
        </template>
        <b-dropdown-item @click="onTriggerAction(RENT_ACTIONS.TRANSFER)">
          <span class="fas fa-exchange-alt mr-1" /> Transferir Aluguel
        </b-dropdown-item>
        <b-dropdown-item @click="onAddExtraTime()">
          <span class="fas fa-clock mr-1" />Tempo Extra
        </b-dropdown-item>
        <b-dropdown-item variant="danger" @click="handleCancelClick">
          <span class="fas fa-ban mr-1" /> Cancelar
        </b-dropdown-item>
      </b-dropdown>
      <div class="w-100">
        <small class="d-flex gap-1">
          <span>{{ toy.name }}</span>
          <!-- <em v-if="isPaused"> (pausado) </em> -->
        </small>
        <span
          v-if="isActive || isPaused"
          class="d-flex flex-wrap align-items-center"
        >
          {{ toy.rent.customer.name }}
          <b-button variant="link" size="sm" @click="openCustomerModal">
            <span class="fas fa-info-circle"></span>
          </b-button>
        </span>
        <!-- Exibe o número do aluguel, mostra o botão de resgate se for 10 ou mais e adiciona checkbox "Não considerar" na direita -->
        <small v-if="isActive || isPaused" class="d-block">
          <div class="d-flex flex-wrap align-items-center gap-1">
            <span class="chip">Aluguel Nº {{ getPoints + 1 }}</span>

            <b-button
              v-if="getPoints + 1 >= 10"
              size="sm"
              variant="outline-secondary"
              class="ml-1"
              @click.stop="onRescueRent"
            >
              Resgatar
            </b-button>

            <b-form-checkbox
              v-model="ignoreRentForPoint"
              name="ignoreRentForPoint"
              class="ml-auto d-flex align-items-center"
              @click.native.stop
              @change="onToggleIgnore"
            >
              <span class="d-flex align-items-center justify-content-center">
                <i class="fas fa-id-card" style="font-size: 18px"></i>
              </span>
              <small class="ml-2">Desconsiderar</small>
            </b-form-checkbox>
          </div>
        </small>
      </div>
    </b-card-title>

    <b-card-text
      v-if="isActive || isPaused"
      class="p-2 m-0"
      :class="statusClass"
    >
      <div class="display-table">
        <div>
          <div class="text-right pr-2">
            <small><b>Período:</b></small>
          </div>
          <div>
            <small class="mr-2">{{ period }}</small>
            <b-button
              size="sm"
              variant="clear-primary"
              class="p-0"
              @click="onChangePeriod"
            >
              <span class="fas fa-redo" />
            </b-button>
          </div>
        </div>
        <div>
          <div class="text-right pr-2">
            <small><b>Tempo:</b></small>
          </div>
          <div>
            <small class="mr-2">{{ getElapsedTime }} min</small>
          </div>
        </div>

        <div v-if="extraTime">
          <div class="text-right pr-2">
            <small><b>Tempo Extra:</b></small>
          </div>
          <div>
            <small class="mr-2">{{ extraTime }} min</small>
          </div>
        </div>

        <div v-if="pausedTime">
          <div class="text-right pr-2">
            <small><b>Pausado:</b></small>
          </div>
          <div>
            <small class="mr-2">{{ pausedTime }} min</small>
          </div>
        </div>

        <div>
          <div class="text-right pr-2">
            <small><b>Início:</b></small>
          </div>
          <div>
            <small>{{ createdAt }}</small>
          </div>
        </div>

        <div>
          <div class="text-right pr-2">
            <small><b>Retorno:</b></small>
          </div>
          <div>
            <small>{{ endsAt }}</small>
          </div>
        </div>

        <div>
          <div class="text-right pr-2">
            <small><b>Valor:</b></small>
          </div>
          <div>
            <small>{{ amount | formatCurrency }}</small>
          </div>
        </div>
      </div>
      <div class="d-flex gap-1 flex-column mt-3">
        <div class="d-flex flex-wrap justify-content-stretch gap-1">
          <b-button
            variant="success"
            class="flex-1"
            @click="onCloseRent(PAYMENT_METHODS_IDS.CASH)"
          >
            DI
          </b-button>
          <b-button
            variant="warning"
            class="flex-1"
            @click="onCloseRent(PAYMENT_METHODS_IDS.CREDIT_CARD)"
          >
            CC
          </b-button>
          <b-button
            variant="info"
            class="flex-1"
            @click="onCloseRent(PAYMENT_METHODS_IDS.DEBIT_CARD)"
          >
            CD
          </b-button>
          <b-button
            variant="secondary"
            class="flex-1"
            @click="onCloseRent(PAYMENT_METHODS_IDS.PIX)"
          >
            PIX
          </b-button>
          <b-button
            variant="outline-info"
            class="flex-1"
            @click="onCloseRent()"
          >
            <span class="fas fa-plus-circle" />
          </b-button>
        </div>
      </div>
    </b-card-text>

    <template v-if="!disabled" #footer>
      <div class="actions d-flex flex-column gap-0">
        <b-button
          v-if="isPaused"
          variant="outline"
          style="border-radius: 0 0 0.2rem 0.2rem !important"
          class="w-100 text-success"
          @click="onTriggerAction(RENT_ACTIONS.RESUME)"
        >
          <span class="fas fa-play mr-1" />
          Resumir
        </b-button>
        <template v-else-if="isActive">
          <b-button
            variant="outline"
            class="w-100 rounded-0 text-muted"
            @click="onTriggerAction(RENT_ACTIONS.PAUSE)"
          >
            <span class="fas fa-pause mr-1" />
            Pausar
          </b-button>
        </template>
        <div v-else class="w-100">
          <b-button
            variant="success"
            class="w-100 rounded-0"
            @click="handleStart"
          >
            <span class="fas fa-flag-checkered mr-1" />
            Iniciar
          </b-button>
          <b-button
            variant="outline-success"
            style="border-radius: 0 0 0.2rem 0.2rem !important"
            class="w-100 rounded-0"
            :class="{ 'btn-darken': !isReopenButtonEnabled }"
            :disabled="!isReopenButtonEnabled"
            @click="onTriggerAction(RENT_ACTIONS.REOPEN_LAST_RENT)"
          >
            <i v-if="!isReopenButtonEnabled" class="fas fa-lock"></i>
            <span v-if="isReopenButtonEnabled" class="fas fa-redo mr-1" />
            Voltar último aluguel
          </b-button>
        </div>
      </div>
    </template>

    <customer-info-modal
      v-if="isActive || isPaused"
      :customer="toy.rent.customer"
      :visible="showCustomerModal"
      :store-id="toy.storeId"
      @close="showCustomerModal = false"
    />
  </b-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { PAYMENT_METHODS, PAYMENT_METHODS_IDS, RENT_ACTIONS } from '@/constants'
import { format } from 'date-fns'
import { formatCurrency } from '@/helpers/numbers'
import CustomerInfoModal from './partials/CustomerInfoModal.vue'
import {
  calculateEndDate,
  calculatePeriod,
  isActive,
  isDelayed,
  isPaused
} from '@/helpers/rents'

export default {
  name: 'ToyRentListItem',
  components: {
    CustomerInfoModal
  },
  filters: {
    formatCurrency
  },
  props: {
    toy: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean
    },
    selectionModeActive: {
      type: Boolean,
      default: false
    },
    checkoutsByStore: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showCustomerModal: false,
      lastTap: 0,
      tapTimeout: null,
      elapsedTime: 0,
      rentAmount: 0,
      productsAmount: 0,
      currentPausedTime: 0,
      ignoreRentForPoint: false
    }
  },
  computed: {
    ...mapGetters('store', ['isAdmin']),
    ...mapState('checkout', ['currentCheckout']),
    ...mapState('store', ['currentStore']),
    ...mapGetters('periods', ['periodsSortedByPrice']),
    isActive() {
      const rent = this.toy.rent
      return isActive(rent)
    },
    isPaused() {
      return isPaused(this.toy.rent)
    },
    isDelayed() {
      return isDelayed(this.endDate)
    },
    period() {
      return calculatePeriod(this.toy.rent)
    },
    createdAt() {
      if (this.toy.rent) {
        const createdAt = new Date(this.toy.rent.createdAt)
        return format(createdAt, "HH'h'mm")
      }
      return ''
    },
    endsAt() {
      return this.toy.rent ? format(this.endDate, "HH'h'mm") : ''
    },
    endDate() {
      return calculateEndDate(this.toy.rent)
    },
    extraTime() {
      return this.toy.rent.extraTime
        ?.filter(({ type }) => type !== 'pause')
        .reduce((acc, { minutes }) => acc + minutes, 0)
    },
    pausedTime() {
      return this.toy.rent.pausedTime
    },
    statusClass() {
      if (this.isPaused) {
        return 'alert-warning'
      }
      if (this.isDelayed) {
        return 'alert-danger'
      }
      return ''
    },
    amount() {
      return this.toy.rent.rentAmount + this.productsAmount
    },
    getElapsedTime() {
      return this.toy.rent.elapsedTime
    },
    getPoints() {
      return this.toy.rent.customer.points?.total_rents_closed
        ? this.toy.rent.customer.points?.total_rents_closed
        : 0
    },
    isReopenButtonEnabled() {
      if (
        !this.toy.rents ||
        !this.toy.rents[0] ||
        !this.toy.rents[0].checkoutId
      ) {
        return false
      }
      const currentCheckoutId = this.checkoutsByStore?.[this.toy.storeId]?.id
      return this.toy.rents[0].checkoutId === currentCheckoutId
    },
    cancelDisabled() {
      const deadline = this.toy.rent.store.cancellationDeadline
      return deadline != null && this.getElapsedTime > deadline
    }
  },
  mounted() {
    console.log(`current user in ToyRentListItem: ${this.isAdmin}`)
  },
  created() {
    this.RENT_ACTIONS = RENT_ACTIONS
    this.PAYMENT_METHODS_IDS = PAYMENT_METHODS_IDS
    this.PAYMENT_METHODS = PAYMENT_METHODS
  },
  methods: {
    onToggleIgnore() {
      if (this.ignoreRentForPoint) {
        // Marcado: não vai somar pontos
        this.$root.$toast?.warning?.(
          'Esse aluguel não somará no cartão fidelidade.'
        )
      } else {
        // Desmarcado: volta a somar pontos
        this.$root.$toast?.success?.(
          'Esse aluguel voltará a somar no cartão fidelidade.'
        )
      }
    },
    handleCancelClick() {
      if (this.cancelDisabled && !this.isAdmin) {
        const deadline = this.toy.rent.store.cancellationDeadline
        this.$bvModal.msgBoxOk(
          `O tempo máximo de cancelamento é ${deadline} minutos.\nPara cancelar, contate um responsável.`,
          {
            title: 'Tempo de cancelamento excedido',
            okTitle: 'OK',
            centered: true,
            variant: 'danger',
            bodyClass: 'pre-line'
          }
        )
      } else {
        this.onTriggerAction(RENT_ACTIONS.CANCEL)
      }
    },
    onChangePeriod() {
      this.$emit('update-store-id', this.toy.storeId)
      this.onTriggerAction(RENT_ACTIONS.CHANGE_PERIOD)
    },
    handleStart() {
      this.$emit('update-store-id', this.toy.storeId)
      this.onTriggerAction(RENT_ACTIONS.START)
    },
    openCustomerModal() {
      this.showCustomerModal = true
    },
    handleCardClick(event) {
      const currentTime = new Date().getTime()
      const tapLength = currentTime - this.lastTap
      clearTimeout(this.tapTimeout)
      if (tapLength < 300 && tapLength > 0) {
        this.handleDoubleClick(event)
      } else {
        this.tapTimeout = setTimeout(() => {
          this.handleSingleClick(event)
          clearTimeout(this.tapTimeout)
        }, 300)
      }
      this.lastTap = currentTime
    },
    handleDoubleClick() {
      if (this.toy.rent && (this.isActive || this.isPaused)) {
        this.$emit('activate-selection-mode', this.toy)
      }
    },
    handleSingleClick() {
      if (
        this.selectionModeActive &&
        (!this.toy.rent || (!this.isActive && !this.isPaused))
      ) {
        this.$emit('new-rental', this.toy)
      }
    },
    onAddExtraTime() {
      const { elapsedTime, rentAmount } = this
      this.onTriggerAction(RENT_ACTIONS.ADD_EXTRA_TIME, {
        elapsedTime,
        rentAmount
      })
    },
    onCloseRent(paymentMethod) {
      const hasProducts =
        this.toy.rent &&
        this.toy.rent.product &&
        this.toy.rent.product.length > 0
      const elapsedTime = this.getElapsedTime
      this.onTriggerAction(RENT_ACTIONS.CLOSE, {
        elapsedTime,
        hasProducts,
        paymentMethod,
        ignoreRentForPoint: this.ignoreRentForPoint
      })
    },
    async onRescueRent() {
      // Utilizando quebras de linha para separar a mensagem principal do aviso.
      const message = `Deseja realmente resgatar o aluguel grátis para ${this.toy.rent.customer.name}?`
      const result = await this.$bvModal.msgBoxConfirm(message, {
        title: 'Confirmação',
        size: 'sm',
        okVariant: 'success',
        okTitle: 'Sim',
        cancelTitle: 'Não',
        centered: true
      })
      if (result) {
        this.onTriggerAction(RENT_ACTIONS.RESCUE)
      }
    },
    onTriggerAction(action, data) {
      this.$emit('trigger-action', { action, toy: this.toy, data })
    }
  }
}
</script>

<style lang="scss" scoped>
.chip {
  display: inline-block;
  padding: 0.15rem 0.5rem;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 999px;
  font-weight: 600;
  font-size: 0.75rem;
  background: #fff;
}
.chip-muted {
  opacity: 0.7;
}

.icon-wrapper {
  position: relative;
  display: inline-block;
}
.icon-wrapper::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 3px;
  background: red;
  transform: rotate(-20deg);
}

.btn-darken {
  filter: brightness(0.1);
}

.card-footer {
  padding: 0px;
}

.actions {
  column-count: 4;
}

.card-title {
  font-size: 1rem;
  font-weight: bold;
}

.display-table {
  display: table;
}
.display-table > div {
  display: table-row;
}
.display-table > div > div {
  display: table-cell;
}

.card {
  width: 100%;
  max-width: none;
  height: 100%; /* opcional: para cards com mesma altura na coluna */
}

/* opcional: evita overflow interno que impeça o item de encolher/expandir */
:host,
.card {
  min-width: 0;
}

.toy-name {
  font-size: calc(1.7vh);
}

.btn-cancel {
  position: absolute;
  right: 10px;
  top: 10px;
}

.btn {
  font-size: 13px;
}
</style>
